{
  "comment": "M7 spec §2.3 (S7): tiers advance on a stated claim. attemptsPerDay per faction day per tier; a retry also needs a newly read log or the next faction day. unlock = when an attempt opens (tier 2: proof weight ≥ proofWeight in ≥ threads threads; tier 3: watch weight; tier 4: the report core or the lab notes; tier 5: the 50-A file or Hale's copy terms). safetyNet: Kell (or the Mutual archivist when Holdfast standing ≤ holdfastRefusesAt) for credits only, after failedAttempts failures plus onlineDaysAfter online days, or every proof of the template's thread read (the fees are not in the spec: placeholders). templates: one per tier; a slot's type picks which read words enter the pool (the template's slot types only), and the pool always carries the decoys; fallback = who takes the claim on comms when the recipient's dock is refused (§3.1); questions = the Logs screen's open questions the claim answers. words: display text and slot type per word id. feedback.wrong is the only thing a wrong claim says. Placeholders for the balance pass (M7 spec §15 item 4); tune freely.",
  "attemptsPerDay": 2,
  "unlock": {
    "tier2": {
      "proofWeight": 1,
      "threads": 2
    },
    "tier3": {
      "watchWeight": 2
    },
    "tier4": {
      "items": [
        "report_core",
        "lab_notes"
      ]
    },
    "tier5": {
      "items": [
        "settlement_50a"
      ],
      "flags": [
        "hale_deal"
      ]
    }
  },
  "safetyNet": {
    "failedAttempts": 2,
    "onlineDaysAfter": 3,
    "kellFee": 5000,
    "archivistFee": 5000,
    "holdfastRefusesAt": -50
  },
  "templates": [
    {
      "tier": 2,
      "recipient": "mutualScrapyard",
      "thread": "evacuation",
      "sentence": "The Collapse took {0}, and the {1} were still {2} when the gate went dark.",
      "slots": [
        {
          "type": "duration",
          "answer": "11_days"
        },
        {
          "type": "hull",
          "answer": "settler_ships"
        },
        {
          "type": "queue",
          "answer": "held_in_queue"
        }
      ],
      "decoys": [
        {
          "type": "cause",
          "word": "gate_fault"
        },
        {
          "type": "party",
          "word": "wreckers"
        }
      ],
      "fallback": [],
      "questions": [
        {
          "id": "q.collapse_length",
          "text": "How long did the Collapse take?",
          "after": [
            "evacuation.liner_log",
            "evacuation.gate_control_notice",
            "evacuation.harrow_queue"
          ]
        },
        {
          "id": "q.queue_last",
          "text": "Who was still in the queue when the gate went dark?",
          "after": [
            "evacuation.harrow_queue",
            "evacuation.th0417_manifest",
            "evacuation.liner_log"
          ]
        }
      ]
    },
    {
      "tier": 3,
      "recipient": "kell",
      "thread": "watch",
      "sentence": "The gate {0} whenever {1} is {2}.",
      "slots": [
        {
          "type": "effect",
          "answer": "weakens"
        },
        {
          "type": "ore",
          "answer": "tetherstone"
        },
        {
          "type": "handling",
          "answer": "mined"
        }
      ],
      "decoys": [
        {
          "type": "cause",
          "word": "natural_cycle"
        },
        {
          "type": "party",
          "word": "varro"
        }
      ],
      "fallback": [],
      "questions": [
        {
          "id": "q.holdfast_tally",
          "text": "What are the Holdfast counting?",
          "after": [
            "watch.contract_book_page",
            "watch.kell_tally",
            "watch.harrow_mast_log"
          ]
        },
        {
          "id": "q.refinery_crystalline",
          "text": "Why does only the Refinery buy crystalline?",
          "after": [
            "watch.kell_tally",
            "watch.contract_book_page"
          ]
        }
      ]
    },
    {
      "tier": 4,
      "recipient": "okafor",
      "thread": "report",
      "sentence": "{0} sent the report to {1}, who was {2}, and the evacuation plan was {3}.",
      "slots": [
        {
          "type": "name",
          "answer": "okafor"
        },
        {
          "type": "code",
          "answer": "ops_r7"
        },
        {
          "type": "name",
          "answer": "voss"
        },
        {
          "type": "fate",
          "answer": "defunded"
        }
      ],
      "decoys": [
        {
          "type": "party",
          "word": "meridian"
        },
        {
          "type": "party",
          "word": "varro"
        }
      ],
      "fallback": [
        {
          "speaker": "kell"
        }
      ],
      "questions": [
        {
          "id": "q.ops_r7",
          "text": "Who is OPS-R/7?",
          "after": [
            "report.evac_plan_budget",
            "report.transfer_order",
            "evacuation.column_nine_queue"
          ]
        },
        {
          "id": "q.evac_plan",
          "text": "What happened to the evacuation plan?",
          "after": [
            "report.evac_plan_budget"
          ]
        }
      ]
    },
    {
      "tier": 5,
      "recipient": "recordsDesk",
      "thread": "settlement",
      "sentence": "The {0} accepted {1} in exchange for {2}, signed by {3}.",
      "slots": [
        {
          "type": "party",
          "answer": "authority"
        },
        {
          "type": "cause",
          "answer": "natural_event"
        },
        {
          "type": "consideration",
          "answer": "reopening_costs"
        },
        {
          "type": "official",
          "answer": "hale"
        }
      ],
      "decoys": [
        {
          "type": "party",
          "word": "meridian"
        },
        {
          "type": "party",
          "word": "wreckers"
        }
      ],
      "fallback": [
        {
          "flag": "duarte_exposed",
          "speaker": "mutualArchivist"
        },
        {
          "speaker": "duarte"
        }
      ],
      "questions": [
        {
          "id": "q.claims_closed",
          "text": "Why were the colony claims closed?",
          "after": [
            "settlement.first_ruin",
            "settlement.station_notice",
            "settlement.escrow_ledger"
          ]
        },
        {
          "id": "q.escrow",
          "text": "What did the Authority get for the survey escrow?",
          "after": [
            "settlement.escrow_ledger"
          ]
        }
      ]
    }
  ],
  "words": {
    "11_days": {
      "text": "11 days",
      "type": "duration"
    },
    "9_days": {
      "text": "9 days",
      "type": "duration"
    },
    "3_days": {
      "text": "3 days",
      "type": "duration"
    },
    "settler_ships": {
      "text": "settler ships",
      "type": "hull"
    },
    "ore_haulers": {
      "text": "ore haulers",
      "type": "hull"
    },
    "kt3_escorts": {
      "text": "KT-3 escorts",
      "type": "hull"
    },
    "held_in_queue": {
      "text": "held in queue",
      "type": "queue"
    },
    "cleared_through": {
      "text": "cleared through",
      "type": "queue"
    },
    "weakens": {
      "text": "weakens",
      "type": "effect"
    },
    "steadies": {
      "text": "steadies",
      "type": "effect"
    },
    "tetherstone": {
      "text": "tetherstone",
      "type": "ore"
    },
    "platinum_ore": {
      "text": "platinum ore",
      "type": "ore"
    },
    "mined": {
      "text": "mined",
      "type": "handling"
    },
    "shipped": {
      "text": "shipped",
      "type": "handling"
    },
    "okafor": {
      "text": "Okafor",
      "type": "name"
    },
    "lindqvist": {
      "text": "Lindqvist",
      "type": "name"
    },
    "voss": {
      "text": "Voss",
      "type": "name"
    },
    "ops_r7": {
      "text": "OPS-R/7",
      "type": "code"
    },
    "fin_r2": {
      "text": "FIN-R/2",
      "type": "code"
    },
    "defunded": {
      "text": "defunded",
      "type": "fate"
    },
    "postponed": {
      "text": "postponed",
      "type": "fate"
    },
    "authority": {
      "text": "Authority",
      "type": "party"
    },
    "tethys": {
      "text": "Tethys",
      "type": "party"
    },
    "meridian": {
      "text": "Meridian",
      "type": "party"
    },
    "wreckers": {
      "text": "Wreckers",
      "type": "party"
    },
    "varro": {
      "text": "Varro",
      "type": "party"
    },
    "natural_event": {
      "text": "a natural event",
      "type": "cause"
    },
    "natural_cycle": {
      "text": "a natural cycle",
      "type": "cause"
    },
    "gate_fault": {
      "text": "a gate fault",
      "type": "cause"
    },
    "reopening_costs": {
      "text": "reopening costs",
      "type": "consideration"
    },
    "survey_escrow": {
      "text": "the survey escrow",
      "type": "consideration"
    },
    "claims_dismissal": {
      "text": "a claims dismissal",
      "type": "consideration"
    },
    "hale": {
      "text": "Hale",
      "type": "official"
    },
    "anand": {
      "text": "Anand",
      "type": "official"
    }
  },
  "feedback": {
    "wrong": "This doesn't hold up."
  }
}
